/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SanitizeHtmlPipe} from '../../pipes/sanitize/sanitize-html.pipe';
import {MenuComponent} from './menu.component';
import {ToggleCommandComponent} from './toggle-command/toggle-command.component';
import {LinkComponent} from './link/link.component';
import {DropdownComponent} from './dropdown/dropdown.component';
import {ImageComponent} from './image/image.component';
import {ColorPickerComponent} from './color-picker/color-picker.component';
import {FloatingMenuComponent} from './floating-menu/floating-menu.component';
import {BubbleComponent} from './bubble/bubble.component';
import {TableMenuComponent} from './table/tableMenu.component';

/**
 *
 */
@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    declarations: [
        // pipes
        SanitizeHtmlPipe,

        // components
        MenuComponent,
        ToggleCommandComponent,
        LinkComponent,
        DropdownComponent,
        TableMenuComponent,
        ImageComponent,
        ColorPickerComponent,

        FloatingMenuComponent,
        BubbleComponent
    ],
    providers: [
        SanitizeHtmlPipe
    ],
    exports: [
        MenuComponent,
        FloatingMenuComponent
    ]
})

export class MenuModule {
}
